// extracted by mini-css-extract-plugin
export default {"m":"Summary_m__-UJEQ","mc":"Summary_mc__3OOS+"};